import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import axios from "axios";

export const ModalTimbreEntes = (props) => {
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [values, setValues] = useState({
    idente: "0",
    nombre: "",
    tipo: "",
  });
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [entes, setEntes] = useState([]);

  const txtTipo = useRef();
  const txtNombre = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();

  const onChange = (event) => {
    event.target.value = event.target.value.toUpperCase();

    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const onChangeT = (event) => {
    if (event.which === 13) {
      if (event.target.name === "tipo") {
        txtNombre.current.focus();
      } else if (event.target.name === "nombre") {
        btnAcepta.current.focus();
      }
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (txtNombre.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el Nombre.",
        icono: "informacion",
      });
      sigue = false;
      txtNombre.current.focus();
    }
    if (txtTipo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar un tipo.",
        icono: "informacion",
      });
      sigue = false;
      txtTipo.current.focus();
    } else if (sigue) {
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const seleccionarTipoEntes = () => {
    let campos = "*";
    let nomtab = "tipoente";
    let orden = "idtipoente desc";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setEntes(response.data);
            if (props.operacion > 1) {
              setValues(props.ente);
              txtTipo.current.value = props.ente.tipo;
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/solicitudtimbre/actualizarEntes/${props.operacion}`;
    let body;
    setActivate(true);

    var timbre = [];
    timbre.push({
      nombre: txtNombre.current.value.trim(),
      idente: values.idente,
      tipo: txtTipo.current.value,
    });

    body = {
      entes: timbre,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setActivate(false);
    setDeshabilitado(false);
    setValues({
      nombre: "",
      idente: "0",
      tipo: "",
    });
  };

  const handleCloseSi = () => {
    Actualizar();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarModal = () => {
    props.onHide(1);
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cancelar = () => {
    blanquear();
    props.onHide(0);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarTipoEntes();
        if (props.operacion >= 3) {
          setDeshabilitado(true);
        }
      }}
    >
      <Modal.Header className="azulGradiant2">
        <Modal.Title style={{ color: "#fff" }}>Gestionar Entes.</Modal.Title>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body
        className="amanecergris"
        style={{ backgroundColor: "#FFF", color: "" }}
      >
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div className="col-md-12" style={{ height: "65vh", overflow: "auto" }}>
          <div
            className="row col-md-12"
            style={{ fontFamily: "Times New Roman, Times, serif" }}
          >
            <fieldset className=" row col-sm-12 mx-auto border-azul rounded">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px" }}
              >
                Datos del Ente
              </legend>
              <div className="input-group input-group-sm col-sm-12 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  TIPO ENTE:
                </label>
                <select
                  name="tipo"
                  disabled={deshabilitado}
                  className="form-control"
                  ref={txtTipo}
                  defaultValue={values.tipo}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                >
                  <option value="">- Seleccione un tipo -</option>
                  {entes &&
                    entes.map((item, i) => (
                      <option key={i} value={item.idtipoente}>
                        {item.tipo}
                      </option>
                    ))}
                </select>
              </div>

              <div className="input-group input-group-sm col-sm-12 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  ENTE:
                </label>
                <textarea
                  disabled={deshabilitado}
                  style={{ minHeight: 50 }}
                  name="nombre"
                  autoComplete="off"
                  ref={txtNombre}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                  value={values.nombre}
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="Descripcion"
                />
              </div>
            </fieldset>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          disabled={props.operacion === 4 ? true : false}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/timbre_fiscal_electronico/modal_timbre_entes.js